import { render, staticRenderFns } from "./AddLightCourseModal.vue?vue&type=template&id=76aa5ed3&"
import script from "./AddLightCourseModal.vue?vue&type=script&lang=js&"
export * from "./AddLightCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports